import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
interface ServiceSectionProps {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  imageUrl: string;
  features: string[];
  reversed?: boolean;
}
export const ServiceSection: React.FC<ServiceSectionProps> = ({
  id,
  title,
  description,
  icon,
  imageUrl,
  features,
  reversed = false
}) => {
  return <section id={id} className={`py-16 ${reversed ? 'bg-gray-50' : 'bg-white'}`} data-id="element-323">
      <div className="container mx-auto px-4" data-id="element-324">
        <div className={`flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-12`} data-id="element-325">
          <div className="md:w-1/2 group" data-id="element-326">
            <div className="rounded-2xl overflow-hidden shadow-xl transform transition-all duration-500 group-hover:shadow-2xl group-hover:-translate-y-1" data-id="element-327">
              <img src={imageUrl} alt={title} className="w-full h-64 md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-328" />
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-329">
            <div className="flex items-center mb-5" data-id="element-330">
              <div className="bg-blue-50 p-4 rounded-xl mr-5 shadow-md" data-id="element-331">
                {icon}
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800" data-id="element-332">
                {title}
              </h2>
            </div>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-333">
              {description}
            </p>
            <div className="bg-white rounded-xl shadow-lg p-7 border-l-4 border-blue-500 transition-all duration-300 hover:shadow-xl" data-id="element-334">
              <h3 className="text-xl font-semibold mb-5 text-blue-700" data-id="element-335">
                What We Offer:
              </h3>
              <ul className="space-y-3" data-id="element-336">
                {features.map((feature, index) => <li key={index} className="flex items-start group" data-id="element-337">
                    <span className="bg-green-100 p-1 rounded-full mr-3 mt-0.5 flex-shrink-0 group-hover:bg-green-200 transition-colors duration-300" data-id="element-338">
                      <CheckIcon className="h-4 w-4 text-green-600" data-id="element-339" />
                    </span>
                    <span className="text-gray-700" data-id="element-340">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-8 flex flex-wrap gap-4" data-id="element-341">
              <a href="#request-service" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 flex items-center text-lg" data-id="element-342">
                Request Service
                <ArrowRightIcon className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" data-id="element-343" />
              </a>
              <a href="tel:2398886268" className="bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-md font-medium transition-all duration-300 shadow-sm hover:shadow-md text-lg" data-id="element-344">
                Call for Details
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};